export default "__VITE_ASSET__kY8cGo1a__"